import { useMemo } from 'react';
import type React from 'react';

import { Redirect } from '@change-corgi/core-react/router';
import { TrackingContext } from '@change-corgi/core-react/tracking';

import { useQueryParamValue } from 'src/app/shared/hooks/location';

import { Layout } from '../layout';

export const ExternalUrl: React.FC = () => {
	const url = useQueryParamValue('to');

	const validUrl = useMemo(() => {
		try {
			return !!url && !!new URL(url);
		} catch (e) {
			return false;
		}
	}, [url]);

	if (!url) {
		return <Redirect to="/" reason="missing_url" />;
	}
	if (!validUrl) {
		return <Redirect to="/" reason="invalid_url" />;
	}

	return (
		<TrackingContext properties={{ url }}>
			<Layout />
		</TrackingContext>
	);
};
